import React, { useState,useEffect } from "react";
import {getUserDetails} from "../../services/userServices"; // Asegúrate de que esta función esté definida en userServices.js

export default function UserDetails() {
    const [userDetails, setUserDetails] = useState([]);

    useEffect(() => {
        const fetchUserDetails = async () => {
        try {
            if (!userDetails.length) {
                const userDetailsData = await getUserDetails();
                setUserDetails(userDetailsData);
                
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            setUserDetails([]); // En caso de error, también aseguramos que el estado no quede en null
        }
          
        };

    
        fetchUserDetails();
      }, [userDetails.length]); // El array vacío asegura que esto se ejecute solo una vez al montar el componente
    
    return (
        <div className="user-details">
            <h2> {userDetails?.nombre} </h2>
        </div>
    );
}